<template>
  <div class="pilingcontainer">
    <div v-if="!showIcon" class="infoview">
      <input id="btnStart" @click="startAnima" type="button" class="btn btn-primary" value="开始" />
      <input id="btnStop" @click="stopAnima" type="button" class="btn btn-primary" value="停止" />
      <input id="btnStop" @click="resetAnima" type="button" class="btn btn-primary" value="复原" />
    </div>
    <div v-if="showIcon" class="icon-div">
      <a class="icon-start" @click="startAnima"></a>
      <a class="icon-stop" @click="stopAnima"></a>
      <a class="icon-reset" @click="resetAnima"></a>
    </div>
    <div v-if="timeline.timeStr" class="tableview2" :style="infoview2Style">
      <table>
        <tr>
          <td>{{ pileCode || $route.query.pileCode }}</td>
          <td>{{ timeline.timeStr.substring(0,10) }}</td>
        </tr>
        <tr>
          <td>时间</td>
          <td>{{ timeline.timeStr.substring(10,19) }}</td>
        </tr>
        <tr>
          <td>阶段</td>
          <td>{{ (timeline.WorkStatus===0?'造孔':'振密') }}</td>
        </tr>
        <tr>
          <td>深度(m)</td>
          <td>{{ timeline.Depth }}</td>
        </tr>
        <tr>
          <td>填料量(m3)</td>
          <td>{{ timeline.FillingsSum }}</td>
        </tr>
        <tr>
          <td>电流(A)</td>
          <td>{{ timeline.Current }}</td>
        </tr>
        <tr>
          <td>水压(bar)</td>
          <td>{{ timeline.WaterPressure }}</td>
        </tr>
        <tr>
          <td>水流(m3/h)</td>
          <td>{{ timeline.WaterFlow }}</td>
        </tr>
      </table>
    </div>
    <Map :url="configUrl" mapKey="piling" :options="options"  @onload="onMapload" />
    <a v-if="showIcon" class="delete-div" @click="setShowPiling"></a>
    <el-progress class="piling-progress" color="#5E5959" :stroke-width="3" :format="percentage=>percentage.toFixed(0)+'%'" :percentage="percentage"></el-progress>
  </div>
</template>
<script>
import Map from '../../components/mars3d/Map.vue'
import { setPilingGraphic } from '../../../static/util/Piling.js'
export default {
  components: {
    Map
  },
  props: {
    count: {
      type: Number,
      default: 12
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    pileCode: {
      type: String,
      default: ''
    },
    infoview2Style: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    pileCode(val, oldVal) {
      this.getTimelines()
    }
  },
  data() {
    const basePathUrl = window.basePathUrl || ''
    const scale = 1
    return {
      configUrl: basePathUrl + 'static/mapconfig/config.json', // 配置文件
      showPiling: true,
      // 地图对象
      map: {},
      options: {
        scene: {
          //默认视角参数
          center: {lat:29.752997,lng:102.215902,alt:1295,heading:328,pitch:-26},
          shadows: false, //是否启用日照阴影
          removeDblClick: true, //是否移除Cesium默认的双击事件

          //以下是Cesium.Viewer所支持的options【控件相关的写在另外的control属性中】
          sceneMode: 3, //3等价于Cesium.SceneMode.SCENE3D,

          //以下是Cesium.Scene对象相关参数
          showSun: true, //是否显示太阳
          showMoon: true, //是否显示月亮
          showSkyBox: true, //是否显示天空盒
          showSkyAtmosphere: true, //是否显示地球大气层外光圈
          fog: true, //是否启用雾化效果
          fxaa: true, //是否启用抗锯齿

          //以下是Cesium.Globe对象相关参数
          globe: {
            depthTestAgainstTerrain: false, //是否启用深度监测
            baseColor: '#546a53', //地球默认背景色
            showGroundAtmosphere: false, //是否在地球上绘制的地面大气
            enableLighting: false //是否显示昼夜区域
          },
          //以下是Cesium.ScreenSpaceCameraController对象相关参数
          cameraController: {
            zoomFactor: 3.0, //鼠标滚轮放大的步长参数
            minimumZoomDistance: 1, //地球放大的最小值（以米为单位）
            maximumZoomDistance: 50000000, //地球缩小的最大值（以米为单位）
            enableRotate: false, //2D和3D视图下，是否允许用户旋转相机
            enableTranslate: false, //2D和哥伦布视图下，是否允许用户平移地图
            enableTilt: false, // 3D和哥伦布视图下，是否允许用户倾斜相机
            enableZoom: false, // 是否允许 用户放大和缩小视图
            enableCollisionDetection: true //是否允许 地形相机的碰撞检测
          }
        },
        control: {
          baseLayerPicker: false, //basemaps底图切换按钮
          homeButton: false, //视角复位按钮
          sceneModePicker: false, //二三维切换按钮
          navigationHelpButton: false, //帮助按钮
          fullscreenButton: false, //全屏按钮 
        },
        terrain: {
          url: 'http://data.mars3d.cn/terrain',
          show: true
        },
        basemaps: [
          {
            name: '天地图卫星',
            icon: 'img/basemaps/tdt_img.png',
            type: 'tdt',
            layer: 'img_d',
            key: ['7082c0340b9f04cdcb52f476ef81900e'],
            show: true
          }
        ]
      },
      // 桩在地图上缩放的比例
      pileScale: scale,
      // 地形开挖对象
      terrainClip: {},
      // 开挖矩形区域参数
      area: [
        [102.214489,29.755534,1202.1],
        [102.216177,29.754463,1207.5],
        [102.215669,29.753618,1204],
        [102.214055,29.754587,1200.7],
      ],
      // 开挖深度 * 缩放比例
      clipHeight: 36 * scale,
      nowCount1: 1,
      nowCount2: this.count,
      pilingGraphic1: '',
      pilingGraphic2: '',
      timeline: {},
      timelines: [],
      percentage: 0
    }
  },
  beforeCreate() {
    if (!this.mars3d.graphic.PilingGraphic) {
      setPilingGraphic(this.mars3d)
    }
  },
  mounted() {
    this.getTimelines()
  },
  methods: {
    // 关闭回调
    setShowPiling() {
      if (this.showPiling) {
        this.showPiling = false
        this.$emit('onClose', false);
      }
    },
    // 地图构造完成回调
    onMapload(map) {
      console.log("地图构造完成")
      this.map = map
      this.initTerrainClip()
      this.createLayer()
      // this.setIcon()
      this.addUnderground()
      
    },
    // 初始化terrainClip对象
    initTerrainClip() {
      const { map, mars3d, clipHeight } = this
      let image = "./static/mapconfig/img/excavate_kuangqu.jpg"
      this.terrainClip = new mars3d.thing.TerrainClip({
        diffHeight: clipHeight, //井的深度
        image: image,
        imageBottom: "./static/mapconfig/img/excavate_bottom_min.jpg",
        splitNum: 80, //井边界插值数
      })
      map.addThing(this.terrainClip)
      this.terrainClip.addArea(this.area)
    },
    // 获取打桩数据
    getTimelines() {
      const pileCode = this.pileCode || this.$route.query.pileCode
      if (pileCode) {
        // let url = `http://localhost:6401/lkApi/timeline?pileCode=${pileCode}&count=${this.count}`
        let url =  `${this.websiteUrl}/lkApi/timeline?pileCode=${pileCode}&count=${this.count}`
        fetch(url)
          .then(response => response.json())
          .then(json => {
            this.timelines = json.data
            this.timeline = json.data[0][0]
            this.resetAnima()
            this.timelineSize = this.timelines.reduce((total, val) => total + val.length, 0)
          })
          .catch(err => console.log('Request Failed', err)); 
      }
    },
    createLayer() {
      // 创建矢量数据图层
      const { map, mars3d } = this
      const graphicLayer = new mars3d.layer.GraphicLayer()
      map.addLayer(graphicLayer)
      const pilingGraphic1 = new mars3d.graphic.PilingGraphic({
        position: [102.214616,29.754993,1164.7],
        style: {
          url: './static/mapconfig/gltf/t1.glb',
          color: '#FF1919',
          fill: true,
          heading: 100,
          count: this.count,
          spacing: 3.5
        }
      })
      const pilingGraphic2 = new mars3d.graphic.PilingGraphic({
        position: [102.214616,29.754993,1164.7],
        style: {
          url: './static/mapconfig/gltf/t2.glb',
          heading: 100,
          count: this.count,
          spacing: 3.5
        }
      })
      this.pilingGraphic1 = pilingGraphic1
      this.pilingGraphic2 = pilingGraphic2
      graphicLayer.addGraphic(pilingGraphic1)
      graphicLayer.addGraphic(pilingGraphic2)
    },
    startAnima() {
      const { pilingGraphic1, pilingGraphic2 } = this
      if (this.nowCount1 > this.count && this.nowCount2 < 1) {
        this.resetAnima()
      }
      this.interval2 = setInterval(() => {this.animation2(pilingGraphic2)}, 1000)
    },
    stopAnima() {
      window.clearInterval(this.interval2)
      window.clearInterval(this.interval1)
    },
    resetAnima() {
      const { pilingGraphic1, pilingGraphic2 } = this
      window.clearInterval(this.interval2)
      window.clearInterval(this.interval1)
      pilingGraphic1.reset()
      pilingGraphic2.reset()
      this.timeline = this.timelines[0][0]
      this.nowCount1 = 1
      this.nowCount2 = this.count
      this.percentage = 0
    },
    animation1(pilingGraphic) {
      if (this.nowCount1 < this.count + 1) {
        pilingGraphic.showFloor(this.nowCount1)
        this.showTimeline(this.timelines[this.nowCount1 + 11], this.timelineSize)
        this.nowCount1++
      } else {
        window.clearInterval(this.interval1)
        this.percentage = 100
      }
    },
    animation2(pilingGraphic) {
      if (this.nowCount2 > 0) {
        pilingGraphic.showHole(this.nowCount2)
        this.showTimeline(this.timelines[this.count - this.nowCount2], this.timelineSize)
        this.nowCount2--
      } else {
        window.clearInterval(this.interval2)
        // 孔造好了，开始打桩
        this.interval1 = setInterval(() => {this.animation1(this.pilingGraphic1)}, 1000)
      }
    },
    showTimeline(timelines, size) {
      if (timelines && timelines.length > 0) {
        this.timeline = timelines[0]
        this.percentage += 100 / size
        for (let index = 1 ; index < timelines.length; index++) {
          setTimeout(() => { 
            this.timeline = timelines[index]
            this.percentage +=  100 / size
          }, Math.ceil((1000 / timelines.length) * index ))
        }
      }
    },
    setIcon() {
      const { mars3d, map, showIcon } = this
        if (showIcon) {
          const toolButton1 = new mars3d.control.ToolButton({
            title: "开始",
            icon: "./static/icon/start.svg",
            insertIndex: 1, // 插入的位置顺序, 1是home按钮后面
            click: () => {
              this.startAnima()
            }
          })
          map.addControl(toolButton1)
          const toolButton2 = new mars3d.control.ToolButton({
            title: "暂停",
            icon: "./static/icon/stop.svg",
            insertIndex: 2,
            click: () => {
              this.stopAnima()
            }
          })
          map.addControl(toolButton2)
          const toolButton3 = new mars3d.control.ToolButton({
            title: "重置",
            icon: "./static/icon/reset.svg",
            insertIndex: 3,
            click: () => {
              this.resetAnima()
            }
          })
          map.addControl(toolButton3)
          console.log(toolButton1, toolButton2, toolButton3)
        }
    },
    addUnderground() {
      const { map, mars3d } = this
      this.underground = new mars3d.thing.Underground({
        alpha: 0.5
      })
      map.addThing(this.underground)
    }
  }
}
</script>
<style>
.pilingcontainer {
  position: relative;
}
.infoview {
  position: absolute;
  top: 0.6rem;
  left: 0.6rem;
  padding: 0.6rem 0.9rem;
  border-radius: 0.2rem;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0.2rem 0.9rem rgb(128 128 128 / 50%);
  z-index: 19870101;
}
.tableview2 {
  position: absolute;
  top: 4rem;
  left: 0.6rem;
  padding: 0.6rem 0.9rem;
  border-radius: 0.2rem;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0.2rem 0.9rem rgb(128 128 128 / 50%);
  z-index: 19870101;
}
table {
  font-size: 0.8rem;
  font-weight: 400;
  width: 10.55rem;
}
.btn {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  margin-bottom: 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  outline: none;
}
.btn-primary {
  color: #fff;
  background-color: rgba(32, 160, 255, 0.2);
  border: 1px solid #e4eaec;
}
.delete-div {
  z-index: 801;
  top: 0.8rem;
  right: 0.8rem;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-family: "Helvetica Neue", Helvetica, Tahoma, Arial, "Microsoft Yahei", "Hiragino Sans GB", "WenQuanYi Micro Hei", sans-serif;
  pointer-events: auto;
  line-height: initial;
  box-sizing: border-box;
  background-color: transparent;
  display: inline-block;
  vertical-align: top;
  position: absolute;
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url("../../../static/mapconfig/img/close-1.svg");
  background-size: 1.2rem;
}
.icon-div {
  position: absolute;
  right: 2.95rem;
  bottom: 8.4rem;
}
.icon-start {
  z-index: 801;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url("../../../static/icon/start.svg");
  background-size: 2rem;
  position: absolute;
  cursor:pointer;
  width: 2rem;
  height: 2rem;
  background-color: white;
  border-radius: 6px;
}
.icon-stop {
  z-index: 801;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url("../../../static/icon/stop.svg");
  background-size: 2rem;
  position: absolute;
  cursor:pointer;
  top: 2.3rem;
  width: 2rem;
  height: 2rem;
  background-color: white;
  border-radius: 6px;
}
.icon-reset {
  z-index: 801;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url("../../../static/icon/reset.svg");
  background-size: 2.1rem;
  position: absolute;
  cursor:pointer;
  top: 4.6rem;
  width: 2rem;
  height: 2rem;
  background-color: white;
  border-radius: 6px;
}
.piling-progress {
  z-index: 801;
  position: absolute;
  width: 60%;
  bottom: 6%;
  left: 20%;
  font-size: 0.6rem;
  opacity: 0.6;
}
.piling-progress div {
  color: #ffffff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/animation/piling.vue